import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36a90a2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-asterisk me-2" }, null, -1))
const _hoisted_2 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_3 = {
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "รายการค่าใช้จ่าย"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "วันที่"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "จำนวนเงิน")
  ])
], -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-dollar-sign me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_ActivityBudgetOffcanvasComponent = _resolveComponent("ActivityBudgetOffcanvasComponent")!
  const _component_ActivityBudgetFormComponent = _resolveComponent("ActivityBudgetFormComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn btn-primary mb-3",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createClick && _ctx.createClick(...args)))
    }, [
      _hoisted_1,
      _createTextVNode("บันทึกงบประมาณค่าใช้จ่าย ")
    ]),
    _createElementVNode("div", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityBudgets, (activityBudget, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "row-hover",
                    onClick: ($event: any) => (_ctx.selectedClick(activityBudget.id))
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, [
                      _hoisted_6,
                      _createTextVNode(_toDisplayString(activityBudget.subject), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.thaiDate(activityBudget.activityDate)), 1),
                    _createElementVNode("td", null, _toDisplayString(Number(activityBudget.amount).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 1)
                  ], 8, _hoisted_5))
                }), 128))
              ])
            ], 512)
          ]))
    ]),
    _createVNode(_component_ActivityBudgetOffcanvasComponent, {
      ref: "activityBudgetOffcanvas",
      "activity-id": _ctx.activityId,
      "province-id": _ctx.provinceId,
      "activity-budget-id": _ctx.activityBudgetId,
      onEdit: _ctx.editClick,
      onDeleted: _ctx.initialDataTable
    }, null, 8, ["activity-id", "province-id", "activity-budget-id", "onEdit", "onDeleted"]),
    _createVNode(_component_ActivityBudgetFormComponent, {
      ref: "activityBudgetForm",
      "activity-id": _ctx.activityId,
      "province-id": _ctx.provinceId,
      "activity-budget-id": _ctx.activityBudgetId,
      onSubmited: _ctx.initialDataTable
    }, null, 8, ["activity-id", "province-id", "activity-budget-id", "onSubmited"])
  ], 64))
}